<template>
  <div class="list" v-if="dialogs && dialogs.length > 0">
    <div class="list__wrapper" v-bar>
      <div class="list__block">
        <div class="list__items">
          <div
            class="list__item"
            :class="{ active: dialogId === 'all' }"
            v-if="typeDialogs === 'masters'"
            @click="openCommonDialog"
          >
            <div class="list__item-img" :style="{ backgroundImage: getImage(null) }"></div>
            <div class="list__item-text">
              <div class="list__item-name">{{ $t("forms.allHandyman") }}</div>
            </div>
          </div>

          <transition-group name="list" tag="div">
            <div
              class="list__item"
              v-for="(user, index) in dialogs"
              :key="index"
              @click="opentDialog(user)"
              :class="{ active: dialogId == user.id }"
            >
              <div class="list__block-text">{{ user.char }}</div>
              <div
                class="list__item-img"
                :style="{ backgroundImage: getImage(user.companion.image) }"
                :class="{
                  'list__item-img_online': user.is_active_time_shift
                }"
              ></div>
              <div class="list__item-text">
                <div class="list__item-name">{{ user.companion.name }}</div>
                <div
                  class="list__item-time"
                  :class="{ unread: user.unread_count != null && user.unread_count != 0 }"
                >
                  <span v-if="user.last_message">
                    {{
                    user.last_message.type == "text"
                    ? user.last_message.content
                    : $t("global.image")
                    }}
                  </span>
                  <span v-else>{{ $t("global.messageEmpty") }}</span>
                </div>
              </div>

              <div
                class="list__item-unread"
                v-if="user.unread_count != null &&  user.unread_count != 0"
              >{{ hasUnread(user) }}</div>
            </div>
          </transition-group>
          <div class="list__item" v-if="dialogs.length == 0">{{ $t("lists.listEmpty") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
    props: {
        clearDialog: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            defaultImage: '/images/default-user.svg',
        }
    },
    computed: {
        ...mapGetters({
            dialogId: 'dialogIdGetters',
            typeDialogs: 'typeDialogsGetters',
            notifications: 'notificationsGetters',
        }),
        dialogs() {
            return this.$store.state.chat.dialogs
        },
    },
    methods: {
        ...mapMutations({
            setDialogId: 'setDialogId',
            setCompanion: 'setCompanion',
            setIsliveUpdate: 'setIsliveUpdate',
            setDialogUsername: 'setDialogUsername',
        }),
        getImage(image) {
            return `url(${image === null ? this.defaultImage : image}`
        },
        async opentDialog(user) {
            this.$emit('getDialog', user.id, user.companion.image)
            this.setDialogUsername(user.companion.name)
        },
        openCommonDialog() {
            this.setDialogId('all')
            this.$emit('openCommonDialog')
        },
        hasUnread(user) {
            return user.unread_count
            // let count = 0;

            // this.notifications.forEach(element => {
            //   if (element.type !== "message") {
            //     return;
            //   }

            //   if (
            //     element.items[0] &&
            //     element.items[0].client_id &&
            //     element.items[0].client_id === user.id
            //   ) {
            //     count = element.items.length;
            //   }
            // });

            // return count;
        },
        loadFirstDialog() {
            if (this.dialogs && this.dialogs.length > 0) {
                this.opentDialog(this.dialogs[0])
            }
        },
    },
    watch: {
        clearDialog(v) {
            if (v) {
                this.loadFirstDialog()
                this.$emit('dialogChanged')
            }
        },
    },
    mounted() {
        if (this.$route.params.id === undefined) {
            this.loadFirstDialog()
        }
    },
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
.list {
  border-radius: 8px;
  // background-color: #ffffff;
  width: 390px;
  flex-shrink: 0;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  top: 0;
  left: 0;
  @include respond(desktop) {
    width: 310px;
  }
  &__wrapper {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 24px;
    box-sizing: border-box;
  }
  &__add {
    position: absolute;
    right: 25px;
    bottom: -25px;
    display: flex;
    align-items: flex-end;
    &-text {
      color: #4d4d4d;
      font-size: 12px;
      margin-right: 16px;
      font-family: $fontMedium;
    }
    &-button {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background-color: $primaryColor;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-image: url("/images/icon/add.svg");
      background-position: center;
      background-size: 20px;
      background-repeat: no-repeat;
      transition: 0.5s;
      cursor: pointer;
      &:hover {
        background-color: $secondColor;
      }
    }
  }
  &__block {
    display: flex;
    position: relative;
    &-text {
      position: absolute;
      left: 0;
      top: 5px;
      width: 48px;
      flex-shrink: 0;
      font-family: $fontLight;
      font-size: 30px;
      color: #e0e0e0;
      text-align: center;
      text-transform: uppercase;
    }
  }
  &__items {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    // overflow-y: auto;
    // padding-bottom: 24px;
  }
  &__item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 9px 30px 9px 20px;
    width: 100%;
    flex-grow: 1;
    transition: 0.5s;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      background: var(--chat-hover);

      & .list__item-button {
        opacity: 1;
      }
    }

    &.active {
      background-color: var(--chat-hover);
    }

    &-img {
      width: 36px;
      height: 36px;
      background-position: center;
      background-size: cover;
      box-sizing: border-box;
      border-radius: 50%;
      margin-right: 12px;
      flex-shrink: 0;

      &_online {
        border: 3px solid #1fdf49;
      }
    }
    &-text {
      width: calc(100% - 100px);
      // flex-grow: 1;
    }
    &-name {
      font-size: 15px;
      color: var(--menu-text-color);
      font-family: "archivo-medium";
      flex-grow: 1;
      padding-left: 1px;
      padding-right: 1px;
      max-width: 95%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 24px;
    }
    &-time {
      font-family: "archivo-medium";
      font-size: 12px;
      color: var(--label-color);
      padding-left: 1px;
      padding-right: 1px;
      max-width: 95%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 20px;

      &.unread {
        font-family: $fontBold;
      }
    }
    &-unread {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: $primaryColor;
      color: #ffffff;
      font-size: 12px;
      font-family: $fontBold;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
